import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconUnsubscribe = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 6C13.5 5.44772 13.9477 5 14.5 5H18.5C19.0523 5 19.5 5.44772 19.5 6V10C19.5 10.5523 19.0523 11 18.5 11C17.9477 11 17.5 10.5523 17.5 10V8.41421L12.2071 13.7071C11.8166 14.0976 11.1834 14.0976 10.7929 13.7071C10.4024 13.3166 10.4024 12.6834 10.7929 12.2929L16.0858 7H14.5C13.9477 7 13.5 6.55228 13.5 6ZM5.5 8.5C5.5 7.67157 6.17157 7 7 7H10.5C11.0523 7 11.5 7.44772 11.5 8C11.5 8.55228 11.0523 9 10.5 9H7.5V17H15.5V14C15.5 13.4477 15.9477 13 16.5 13C17.0523 13 17.5 13.4477 17.5 14V17.5C17.5 18.3284 16.8284 19 16 19H7C6.17157 19 5.5 18.3284 5.5 17.5V8.5Z"
      fill="currentColor"
    />
  </SvgIcon>
)
